import { FetchResult } from '@apollo/client'
import { client } from '../../..'
import {
  SAVE_TARGET_TEMPLATE,
  DELETE_TARGET_TEMPLATE,
  DUPLICATE_TARGET_TEMPLATE,
} from '../../../graphql/companySettings/CompanySettingsMutations'
import { COMPANY_SETTINGS_TARGETS } from '../../../graphql/companySettings/CompanySettingsQueries'
import {
  ObjectiveTemplateInput,
  DeleteTargetTemplateMutation,
  DeleteTargetTemplateMutationVariables,
  DuplicateTargetTemplateMutation,
  DuplicateTargetTemplateMutationVariables,
  Country,
  SaveTargetTemplateMutation,
  SaveTargetTemplateMutationVariables,
} from '../../../types'

export const targetTemplateModalSaveTarget = async (
  companyId: string,
  country: Country,
  target: ObjectiveTemplateInput,
): Promise<FetchResult<SaveTargetTemplateMutation>> => {
  return await client.mutate<SaveTargetTemplateMutation, SaveTargetTemplateMutationVariables>({
    mutation: SAVE_TARGET_TEMPLATE,
    variables: {
      companyId,
      country,
      objective: target,
    },
    refetchQueries: [
      {
        query: COMPANY_SETTINGS_TARGETS,
        variables: {
          companyId,
          country,
        },
      },
    ],
    awaitRefetchQueries: true,
  })
}

export const targetTemplateModalDeleteTarget = async (
  companyId: string,
  targetId: string,
  country: Country,
): Promise<FetchResult<DeleteTargetTemplateMutation>> => {
  return await client.mutate<DeleteTargetTemplateMutation, DeleteTargetTemplateMutationVariables>({
    mutation: DELETE_TARGET_TEMPLATE,
    variables: {
      objectiveId: targetId,
      companyId,
      country,
    },
    refetchQueries: [
      {
        query: COMPANY_SETTINGS_TARGETS,
        variables: {
          companyId,
          country,
        },
      },
    ],
  })
}

export const duplicateTarget = async (
  companyId: string,
  targetId: string,
  country: Country,
): Promise<FetchResult<DuplicateTargetTemplateMutation>> => {
  return await client.mutate<DuplicateTargetTemplateMutation, DuplicateTargetTemplateMutationVariables>({
    mutation: DUPLICATE_TARGET_TEMPLATE,
    variables: {
      objectiveId: targetId,
      companyId,
      country,
    },
    refetchQueries: [
      {
        query: COMPANY_SETTINGS_TARGETS,
        variables: {
          companyId,
          country,
        },
      },
    ],
  })
}
